var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Katalon Runtime Engine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RE_logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41-Copy-42",
    fill: "#9DCC3D",
    points: "7.38964445e-13 26 13 26 12.9953218 20.8068836 26 0 3.69482223e-13 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41-Copy-11",
    fill: "#67B340",
    transform: "translate(15.459420, 15.821181) scale(-1, 1) translate(-15.459420, -15.821181) ",
    points: "4.91883916 26 21.1279797 26 26 18.1255045 17.595413 5.64236111"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#67B340",
    cx: 11.5104167,
    cy: 13,
    r: 8.35069444
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0931778,5.06027231 C14.6936937,5.25539173 15.256987,5.51210253 15.7783366,5.82113865 L15.779096,7.22783831 L14.6052283,7.93124157 C14.2180429,7.69556509 13.7975579,7.50079106 13.3476982,7.35462278 C10.2285972,6.34116544 6.87849678,8.04812686 5.86503944,11.1672278 C4.8515821,14.2863288 6.55854353,17.6364292 9.6776445,18.6498866 C12.7967455,19.6633439 16.1468459,17.9563825 17.1603033,14.8372815 C17.6363226,13.3722448 17.5121723,11.8562457 16.9234207,10.5553518 C16.9234207,10.5553518 18.8492197,9.01358623 18.8477573,9.01089765 C19.9050291,10.9546699 20.1923915,13.3122378 19.4546537,15.5827612 C18.0294793,19.9689969 13.3184006,22.3694114 8.93216485,20.944237 C4.54592911,19.5190627 2.1455146,14.8079839 3.57068898,10.4217482 C4.99586337,6.03551244 9.7069421,3.63509793 14.0931778,5.06027231 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35069444,16.8548611 L8.35069444,9.14513889 L12.0278373,9.14513889 C13.6992659,9.14513889 14.8692659,10.3151389 14.8692659,11.8194246 C14.8692659,13.4908532 13.532123,14.1037103 13.532123,14.1037103 C14.2229166,15.3183519 14.7410117,16.2293837 15.0864085,16.8368056 C15.1000593,16.8608122 14.3568642,16.8608122 12.856823,16.8368056 L11.5002973,14.4937103 L10.4678373,14.4937103 L10.4678373,16.8548611 L8.35069444,16.8548611 Z M12.752123,11.8194246 C12.752123,11.3737103 12.4178373,11.0394246 11.9164087,11.0394246 L10.4678373,11.0394246 L10.4678373,12.5994246 L11.9164087,12.5994246 C12.4178373,12.5994246 12.752123,12.2651389 12.752123,11.8194246 Z",
    id: "Rc",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReLogo);
export default __webpack_public_path__ + "static/media/RE_logo.25713cb3b36eb568bc000c735c6a2420.svg";
export { ForwardRef as ReactComponent };